import AvailableTrucks from "./AvailableTrucks";

export default AvailableTrucks;
